import { render, staticRenderFns } from "./orderManageDialog.vue?vue&type=template&id=251d2964&scoped=true&"
import script from "./orderManageDialog.vue?vue&type=script&lang=js&"
export * from "./orderManageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251d2964",
  null
  
)

export default component.exports